export const initProductClassRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/productclasses",
          name: "productclass",
          component: () => import("@/pages/manage/productclasses/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/productclasses/:id",
          name: "productclass-id",
          component: () => import("@/pages/manage/productclasses/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
